import { Checkmark } from '@velocity-exchange/icons';
import BottomDrawer from 'src/components/Drawers/BaseDrawers/BottomDrawer/BottomDrawer';
import { cm } from 'src/utils/classNames';
import { BottomDrawerSelectOption } from 'src/components/Inputs/BottomDrawerSelect/types';

export interface BottomDrawerSelectOptionsProps<T> {
	title: string;
	options: BottomDrawerSelectOption<T>[];
	onSelect: (value: T) => void;
	selectedValue: T | undefined;
	closeDrawer: () => void;
	isDrawerClosing: boolean;
	noSelectedCheckmark?: boolean;
}

/**
 * Intended to be used with `BottomDrawerSelect`. This is the bottom drawer that
 * is opened when the select is triggered, presenting its options.
 */
export default function BottomDrawerSelectOptions<T>({
	title,
	options,
	onSelect,
	selectedValue,
	closeDrawer,
	isDrawerClosing,
	noSelectedCheckmark,
}: BottomDrawerSelectOptionsProps<T>) {
	return (
		<BottomDrawer.Container
			closeDrawer={closeDrawer}
			isDrawerClosing={isDrawerClosing}
		>
			<BottomDrawer.Title closeDrawer={closeDrawer}>{title}</BottomDrawer.Title>
			<BottomDrawer.Body className="gap-y-0 py-0">
				{options.map((option, index) => (
					<button
						key={index}
						// Closing the drawer is handled by the parent component.
						onClick={() => onSelect(option.value)}
						className={cm(
							'flex items-center justify-between py-md text-text-default',
							option.value === selectedValue && 'text-purple-link',
							option.className
						)}
					>
						{option.label}
						{!noSelectedCheckmark && option.value === selectedValue && (
							<Checkmark
								size={16}
								// Can be used to style the checkmark from `option.className`.
								data-checkmark
							/>
						)}
					</button>
				))}
			</BottomDrawer.Body>
		</BottomDrawer.Container>
	);
}
